import styles from './index.module.less';

import { IntlMessage } from '$HVUI';
import Button from '$Molecules/Buttons/Button';

const HasAccount = () => {
    return (
        <div>
            <h1 style={{ marginTop: '32px', marginBottom: '48px' }}>
                <IntlMessage
                    id="welcome.do-you-have-a-healthvana-account"
                    defaultMessage="Do you have a Healthvana account?"
                />
            </h1>

            <Button
                element="Link4"
                to="/login"
                style={{ width: '96px' }}
                text={<IntlMessage id="all.yes" defaultMessage="Yes" />}
            />
            <Button
                element="Link4"
                to="/signup"
                style={{ width: '96px', marginLeft: '32px' }}
                kind="alert"
                text={<IntlMessage id="all.no" defaultMessage="No" />}
                marginLeft={18}
            />
            <p style={{ marginTop: 32 }}>
                <strong>
                    <IntlMessage
                        id="welcome.if-you-have-health-insurance-please-have"
                        defaultMessage="If you have health insurance, please have your insurance card or insurance information available before starting."
                    />
                </strong>
            </p>
            <h2 className={styles['what-is-hv']}>
                <IntlMessage
                    id="welcome.what-is-healthvana"
                    defaultMessage="What is Healthvana?"
                />
            </h2>
            <section className={styles['explanation']}>
                <IntlMessage
                    id="welcome.healthvana-is-a-service-that-lets-you"
                    defaultMessage="<p>Healthvana is a service that lets you view your test results, register for medical services, and receive messages from your medical provider in a secure online account.</p>"
                />
                <IntlMessage
                    id="welcome.you-may-have-created-an-account-in"
                    defaultMessage="<p>You may have created an account in the past when visiting a medical clinic or requesting test results from your medical provider.</p>"
                />
            </section>
        </div>
    );
};

export default HasAccount;
